import { CdkColumnDef, CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { PopoverModule } from 'ngx-smart-popover';
import { AppCommonModule } from '../app-common.module';
import { ReportsModule } from '../reports/reports.module';
import { InsightsRoutingModule } from './insights-routing.module';
import { InsightsOverviewComponent } from './overview/insights-overview.component';
import { TopCustomersByExposureComponent } from './top-customers-by-exposure/top-customers-by-exposure.component';
import { CustomersByExposureComponent } from './customers-by-exposure/customers-by-exposure.component';
import { InsightsComponent } from './insights.component';
import { SupplyChainDirectCommonModule } from '../supply-chain/direct/supply-chain-direct-common.module';
import { LsqCommonModule, LsqTablesModule } from '@lsq-frontend/common-ui';

@NgModule({
    imports: [
        AppCommonModule,
        LsqCommonModule.forChild(),
        InsightsRoutingModule,
        PopoverModule,
        CdkTableModule,
        LsqTablesModule.forChild(),
        ReportsModule,
        SupplyChainDirectCommonModule
    ],
    declarations: [
        InsightsComponent,
        InsightsOverviewComponent,
        TopCustomersByExposureComponent,
        CustomersByExposureComponent
    ],
    providers: [CdkColumnDef]
})
export class InsightsModule {}
